import { DictionaryProduct, DictionaryProductSchema } from "etl/types";
import { createAppAsyncThunk } from "core/src/store/store.types";
import { ItemMapping } from "core/src/slices/etlData/slice/etlData.types";

export interface PatchProductMappingRequest {
	productsMapping: ItemMapping;
}

export type PatchProductMappingResponse = {
	dictionaryProducts: DictionaryProduct[];
};

export const patchProductMapping = createAppAsyncThunk<PatchProductMappingResponse, PatchProductMappingRequest>(
	"patchProductMapping",
	async ({ productsMapping }, { extra, getState }) => {

		const {
			extractProducts,
			dictionaryProducts,
			extractBrands,
			extractCategories,
			extractSuppliers
		} = getState().etlData;

		const tmpDictionaryProducts = [...dictionaryProducts];

		const extractProduct = extractProducts.find((extractProduct) => extractProduct.id == productsMapping.extractId);
		const dictionnaryProduct = dictionaryProducts.find((dictionaryProduct) => dictionaryProduct.id == productsMapping.dicoId);

		const correspondingBrandId = extractBrands.find((brand) => brand.libelle === extractProduct?.marque)?.hb_id;
		const correspondingCategoryId = extractCategories.find((category) => category.libelle === extractProduct?.categorie)?.hb_id;
		const correspondingSupplierId = extractSuppliers.find((supplier) => supplier.libelle === extractProduct?.fournisseur)?.hb_id;

		if (dictionnaryProduct && extractProduct) {

			const dictionaryProductsUpdated = await extra.etlClient.update(
				DictionaryProductSchema,
				dictionnaryProduct.id,
				{
					hb_product_id: extractProduct?.hb_id,
					hb_product_libelle: extractProduct?.libelle,
					hb_brand_libelle: extractProduct?.marque,
					hb_brand_id: correspondingBrandId,
					hb_supplier_libelle: extractProduct?.fournisseur,
					hb_supplier_id: correspondingSupplierId,
					hb_category_libelle: extractProduct?.categorie,
					hb_category_id: correspondingCategoryId,
				},
			);

			if (dictionaryProductsUpdated) {
				tmpDictionaryProducts.splice(
					tmpDictionaryProducts.findIndex((product) => product.id === productsMapping.dicoId),
					1,
					dictionaryProductsUpdated.data
				);
			}

		}

		return {
			dictionaryProducts: tmpDictionaryProducts
		}
	}
);
